export type DaySearchNurseIdSources = {
	showActual: boolean;
	/** The scheduled view's rows. */
	scheduledNurseIds: number[];
	/** The Actual view's rows: resolved punches, plus scheduled shifts that never got one (No Punch). */
	actualNurseIds: number[];
	/** Call In has no shift behind it, so it is not in either shift list. */
	callInNurseIds: number[];
	/** Time off is its own section in both views. */
	ptoNurseIds: number[];
};

/**
 * Everyone the day's table can show for the current view, once each, in the order they are found.
 * The staff search offers exactly this list, so anyone visible on the day — in any section, not just
 * the ones with a shift — can be picked.
 */
export function collectDaySearchNurseIds({ showActual, scheduledNurseIds, actualNurseIds, callInNurseIds, ptoNurseIds }: DaySearchNurseIdSources): number[] {
	const shiftNurseIds = showActual ? [...actualNurseIds, ...callInNurseIds] : scheduledNurseIds;
	return Array.from(new Set<number>([...shiftNurseIds, ...ptoNurseIds]));
}
